<template>
    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 11">
        <title>arrow</title>
        <polygon points="32.06 5.5 24.06 0 24.06 5 0 5 0 6 24.06 6 24.06 11 32.06 5.5"  />
    </svg>
</template>

<script>
export default {
    name: "MapIcon",
};
</script>

<style scoped></style>
